import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classname';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../components/table/main';

import Search from '../../shared/search/main';
import Calendar from '../../shared/calendar/main';
import SwitchControlSingleDecorator from  '../../shared/switch-control/single/main';
import createForm from '../components/adv-requests-form/main';

const AdvForm = createForm('advForm');

const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content adv-requests-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Advertisers registration requests')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="adv-requests-list__form-position">
					</div>

					<div className="ui-control-bar">
						<div className="ui-control-bar__item modify-item---search">
							<div className="ui-control-bar__item-position">
								<Search
									form="advRequestsSearchForm"
									action={props.search}
									{...props}
									autoFocus={true}
									initialValues={props.searchData} />
							</div>
						</div>

						<div className="ui-control-bar__item modify-item---calendar">
							<div className="ui-control-bar__item-position">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<SwitchControlSingleDecorator>
									{props.quickFilters.map((filter, id) => (
										<button
											key={id}
											className={cn({
												'active': filter.active,
												'ui-btn ui-btn-secondary': true
											})}
											onClick={() => props.applyQuickFilter(filter.name)}
										>
											{props.intl(filter.placeholder)}
										</button>
									))}
								</SwitchControlSingleDecorator>
							</div>
						</div>

						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>{props.intl('Apply')}</button>
								<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
							</div>
						</div>
					</div>

					<div className="adv-requests-list__table-position">
						<Table {...props} />
						<AdvForm {...props} enableReinitialize={true} initialValues={props.modalData && props.modalData.fields} />
					</div>
				</div>
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		searchData: selectors.getSearchData(state),
		quickFilters: selectors.getQuickFilters(state),
		calendar: selectors.getCalendar(state),
		pagination: selectors.getPagination(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		shouldShowAdvRequestForm: selectors.getShouldShowAdvRequestForm(state),
		isAdvFormEditMode: selectors.getAdvFormEditMode(state),
		modalData: selectors.getModalData(state),
		advRequestOpenedId: selectors.getAdvFormOpenedId(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/advertisers-requests/list/main.js